import { render, staticRenderFns } from "./login_header.vue?vue&type=template&id=7ffac4dc&scoped=true"
import script from "./login_header.vue?vue&type=script&lang=js"
export * from "./login_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffac4dc",
  null
  
)

export default component.exports